import { DatePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import { standardDateFormat } from "utils/dateUtils";

type FilterDatePickerProps = {
  value?: Date;
  onChange: (v?: Date) => void;
  label: string;
};

export default function FilterDatePicker({
  value,
  onChange,
  label,
}: Readonly<FilterDatePickerProps>) {
  const handleValueChange = (value: Date | null) => {
    if (value && isValid(value)) {
      onChange(value);
    } else if (value == null) {
      onChange(undefined);
    }
  };

  return (
    <DatePicker
      label={label}
      value={value ?? null}
      onChange={handleValueChange}
      format={standardDateFormat}
      slotProps={{
        textField: {
          variant: "outlined",
          size: "small",
          fullWidth: true,
        },
        actionBar: {
          actions: ["clear", "cancel"],
        },
      }}
    />
  );
}
